<template>
  <div class="flex flex-col h-screen antialiased bg-white">
    <Header />
    <main class="flex flex-1 overflow-hidden md:flex-row">
      <StoreList />
      <div class="relative flex-1 h-full">
        <OpenLayersMap />
        <UiOnboarding />
      </div>
    </main>
    <Footer />
  </div>
</template>

<script setup lang="ts">
const { setLocale } = useI18n()
setLocale(window.navigator.language)
</script>
